export default function isObject(item: any): item is Object {
  return item !== null && typeof item === "object" && !Array.isArray(item);
}
